import { PropsWithChildren, useEffect } from 'react';
import { TXProvider } from '@transifex/react';
import {
  PseudoTranslationPolicy,
  SourceStringPolicy,
  tx,
} from '@transifex/native';

//TODO: share impl between frontend apps?

const MissingPolicy =
  process.env.NEXT_PUBLIC_NODE_ENV === 'development'
    ? PseudoTranslationPolicy
    : SourceStringPolicy;

function getLanguageForTransifex() {
  const [language] = navigator.language.split('-');
  switch (language) {
    case 'nb':
    case 'nn':
    case 'no':
      return 'nb';
    case 'da':
      return 'da';
    default:
      return 'en';
  }
}

export function initTransifex() {
  tx.init({
    token: process.env.NEXT_PUBLIC_TRANSIFEX_TOKEN,
    missingPolicy: new MissingPolicy(),
  });
  void tx.setCurrentLocale(getLanguageForTransifex());
}

export function TransifexProvider({ children }: PropsWithChildren<object>) {
  useEffect(() => {
    initTransifex();
  }, []);
  return <TXProvider>{children}</TXProvider>;
}
